import { render, staticRenderFns } from "./ConfigurationSaleInvoiceTypesCard.vue?vue&type=template&id=1186312f&scoped=true&"
import script from "./ConfigurationSaleInvoiceTypesCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSaleInvoiceTypesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186312f",
  null
  
)

export default component.exports